import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject } from "rxjs";
import { UniversalStorage } from "../storages/universal.storage";

@Injectable()
export class LanguageService {
  public static readonly defaultLanguage: string = 'de-CH';
  private readonly storageKey: string = 'bn.language.code';
  currentLanguage$ = new BehaviorSubject<string | null>(null);

  constructor(private readonly translateService: TranslateService,
    private readonly universalStorage: UniversalStorage) { }

  get currentLanguageCode(): string {
    return this.translateService.currentLang ?? 'de-CH';
  }

  async init(): Promise<void> {
    // Try to get language from query parameters
    let language: string | null = null;

    if (!language) {
      // If language was not provided (e.g. on reload) use the stored language if available
      const storedLanguage = this.getStoredLanguage();

      if (storedLanguage) {
        language = storedLanguage;
      }
      else {
        // Otherwise use the default language
        language = LanguageService.defaultLanguage;
      }
    }

    this.translateService.setDefaultLang(LanguageService.defaultLanguage);
    this.setLanguage(language);
  }

  setLanguage(code: string): void {
    this.storeLanguage(code);
    this.translateService.use(code).subscribe();
    this.currentLanguage$.next(code);
  }

  private storeLanguage(key: string): void {
    this.universalStorage.setItem(this.storageKey, key);
  }

  private getStoredLanguage(): string | null {
    return this.universalStorage.getItem(this.storageKey);
  }
}
